import withNavigate from "../../../routes/withNavigate";
import CcavenueReportsContainer from "./CcavenueReportsContainer.jsx";
import CcavenueReportsStore from "./CcavenueReportsStore";

export default CcavenueReportsStore(withNavigate(CcavenueReportsContainer));